import {BasicCartItem} from 'components/common/BasicCartItem'
import LocalisedDate from 'components/common/LocalisedDate'
import {Frame} from 'components/system/Frame'
import {Exp1, Ventrata} from 'types'
import {formatAvailabilityId} from 'utils/formatAvailabilityId'

type Props = {
  booking: Ventrata.Booking
  exp1Product: Exp1.Product | null
}

export const CartItem = ({booking, exp1Product}: Props) => {
  return (
    <BasicCartItem
      booking={booking}
      exp1Product={exp1Product}
      render={(cartItemData) => {
        return (
          <div className="flex flex-col gap-4">
            <div className="text-french-blue-030 text-lg font-bold">
              <LocalisedDate date={formatAvailabilityId(booking.availabilityId)} />
            </div>
            <Frame className="flex gap-4 w-full">{cartItemData}</Frame>
          </div>
        )
      }}
    />
  )
}
